const lo      = require('lodash')
const slashes = require('slashes')

export default {
    numFormat: (num) => {
        let lang = localStorage.getItem('vueml-lang') || 'Vietnamese'

        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, lang === 'Vietnamese' ? "$1." : "$1,")
    },

    errors: (errors) => {
        return lo.has(errors[0], 'validation') ? Object.values(errors[0].validation)[0][0] : errors[0].message;
    },

    data: (result, obj) => {
        return result.data.data ? result.data.data[obj] : []
    },

    toString: (array) => {
        return slashes.add(JSON.stringify(array))
    },

    clearAll: () => {
        let after = document.querySelectorAll('div.item-after')
        after.forEach((item) => {
            if (! item.querySelector('span'))
                item.innerText = ''
        })
    },

    userToken: () => {
        if (localStorage.userLogin) {
            let userLogin = JSON.parse(localStorage.userLogin)

            return userLogin.token;
        }

        return '';
    },

    hasPermission: (per) => {
        let has = false
        if (localStorage.permission) {
            let permissions = JSON.parse(localStorage.permission)
            has = permissions[per]
        }

        return has
    },

    isMobile: () => {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
}